import { createFileRoute, notFound } from '@tanstack/react-router'
import { RoomDetail } from '@/components/custom/ui/clients/tempula/rooms/RoomDetail'
import HomestayFooterCmp from '@/components/custom/ui/clients/tempula/homestay/homestayFooter'
import HomestayNavbar from '@/components/custom/ui/clients/tempula/homestay/homestayNavbar'
import HomestayfooterConfig from '@/constant/config/clients/tempula/homestay/homestayFooterConfig'
import HomenavConfig from '@/constant/config/clients/tempula/homestay/homestayNavConfig'
import { ROOM_MAP, type RoomSlug } from '@/constant/config/clients/tempula/rooms/roomMap'
import { TEMPULA_ROOMS } from '@/constant/config/clients/tempula/rooms/roomCatalogue'
import { SITE_URL, buildPageHead } from '@/constant/config/clients/tempula/seo'

export const Route = createFileRoute('/_clients/tempula/rooms/$roomId')({
  beforeLoad: ({ params }) => {
    if (!(params.roomId in ROOM_MAP)) throw notFound()
  },

  head: ({ params }) => {
    const slug = params.roomId as RoomSlug
    if (!(slug in ROOM_MAP)) return {}

    const { catalogueId, config } = ROOM_MAP[slug]
    const room    = TEMPULA_ROOMS[catalogueId]
    const ogImage = config.sections[0]?.images[0] ?? '/home.webp'
    const pageUrl = `${SITE_URL}/tempula/rooms/${slug}`

    const title       = `${room.fullName} | Tempula Homestay`
    const description = `Book ${room.fullName} in Siliguri, India — ${room.tagline}. Up to ${room.capacity} guests · WiFi, pool & more · ₹${room.pricePerNight.toLocaleString('en-IN')}/night.`

    return buildPageHead({ title, description, url: pageUrl }, {
      image: ogImage,
      extraMeta: [{
        'script:ld+json': {
          '@context': 'https://schema.org',
          '@type': 'HotelRoom',
          name: room.fullName,
          description,
          url: pageUrl,
          occupancy: {
            '@type': 'QuantitativeValue',
            maxValue: room.capacity,
          },
          amenityFeature: room.amenities.map(a => ({
            '@type': 'LocationFeatureSpecification',
            name: a.title,
            value: true,
          })),
          offers: {
            '@type': 'Offer',
            price: room.pricePerNight,
            priceCurrency: 'INR',
            availability: 'https://schema.org/InStock',
            priceSpecification: {
              '@type': 'UnitPriceSpecification',
              price: room.pricePerNight,
              priceCurrency: 'INR',
              unitCode: 'DAY',
              unitText: 'night',
            },
          },
          containedInPlace: {
            '@type': 'LodgingBusiness',
            name: 'Tempula Homestay',
            url: SITE_URL,
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Siliguri',
              addressRegion: 'West Bengal',
              addressCountry: 'IN',
            },
          },
        },
      }],
    })
  },

  component: RouteComponent,
})

function RouteComponent() {
  const { roomId } = Route.useParams()
  const { config, catalogueId } = ROOM_MAP[roomId as RoomSlug]

  return (
    <div className="bg-BgGallery">
      <div className="fixed top-0 left-0 w-full z-50">
        <HomestayNavbar {...HomenavConfig} />
      </div>
      <RoomDetail roomId={catalogueId} {...config} />
      <HomestayFooterCmp {...HomestayfooterConfig} />
    </div>
  )
}
